import { getNessOpenInfoBadge } from '@modules/Ness/App/ProductBadge/__deprecated/nessProductBadge.js';
import { find, go, head, map, sel } from 'fxjs/es';
import { MpShopProductS } from '../../../../../../MpShop/Product/S/Function/module/MpShopProductS.js';
import { creatorPriceOfProduct } from '../../../../../../ProductColorPrice/S/fs.js';
import { UtilS } from '../../../../../../Util/S/Function/module/UtilS.js';
import { MShopAppProductItemS } from '../../../../Product/Item/S/Function/module/MShopAppProductItemS.js';

const to = 10;
const of = 5;
const power = Math.pow(to, of);

export const OPTION_WIDTH = 600;

export const toFixed3 = (r) => Math.round(parseFloat((r * 100 * power).toFixed(of))) / power;

export const isOdd = (r) => r % 2 == 1;

export const processOpenInfoProductListResponse = ({
  store_id,
  name,
  domain_name,
  logo_img,
  thumbnail_img,
  banner_img,
  base_url,
  products,
}) => {
  return {
    store_id,
    link: `${base_url}/${domain_name}`,
    name,
    logo_img: logo_img ? `https:${logo_img}` : null,
    thumbnail_img: thumbnail_img ? `https:${thumbnail_img}` : null,
    banner_img: banner_img ? `https:${banner_img}` : null,
    products: processOpenInfoProductList(products, { domain_name, base_url }),
  };
};

const processOpenInfoProductList = (products, { domain_name, base_url }) => {
  return go(
    products,
    map((product) => {
      const {
        id,
        thumbnails,
        name = '',
        _: {
          spo,
          base_product: {
            thumbnail_ratio: _thumbnail_ratio,
            base_product_color_face_url,
            name: base_product_name,
          } = {},
          stores_product: {
            sell_start_at,
            sell_end_at,
            quantity,
            is_quantity_public,
            order_count,
            public_at,
            _: { stores_products_token_gates } = {},
          } = {},
        } = {},
      } = product;

      const thumbnail = go(thumbnails, sel('value'), find(sel('is_thumb')), (v) => v || head(v)) || {};
      const thumbnail_ratio = thumbnail.composite_template_id ? 1 : _thumbnail_ratio;
      const ratio_size = Number.parseFloat(thumbnail_ratio) * 100 || 84;
      const is_100 = ratio_size == 100;
      const width = is_100
        ? OPTION_WIDTH
        : (() => {
            const val = Math.round((OPTION_WIDTH * ratio_size) / 100);
            return val + (isOdd(OPTION_WIDTH) == isOdd(val) ? 0 : 1);
          })();
      const max_size = (is_100 ? ratio_size : toFixed3(width / OPTION_WIDTH)) || 100;

      const url = thumbnail.url || base_product_color_face_url;
      const padding_size = (OPTION_WIDTH - width) / 2 || void 0;
      const bg = 'f6f6f6';

      const url_data = {
        url,
        width: width || void 0,
        padding_size,
        quality: 92,
        bg,
      };
      /* @@thumbnail is_pb 체크 삭제할 친구(사이어티 행사용) @@ */
      if (thumbnail.is_pb && thumbnail.width != thumbnail.height) {
        url_data.r = 80;
      }

      const res = {
        product_id: id,
        link: `${base_url}/${domain_name}/products/${id}`,
        name: UtilS.trim(name),
        base_product_name,
        price: creatorPriceOfProduct(product),
        image: MpShopProductS.setOnDemandJpegUrl(url_data),
        image_ratio: max_size,
      };

      if (UtilS.isNessApp()) {
        return {
          ...res,
          type: getNessOpenInfoBadge({ public_at }),
        };
      } else {
        const states = MShopAppProductItemS.setSimpleBadge({
          spo_item_stocks: spo?._?.spo_item_stocks,
          sell_start_at,
          sell_end_at,
          quantity,
          order_count,
          is_quantity_public,
          is_sptg: !!stores_products_token_gates.length,
        });

        return {
          ...res,
          states,
        };
      }
    }),
  );
};
